import Instance from "../../../../Axios";

// New Actions for the app

const GetAllCredDestinatarios = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/allCredDestinatarios`)
    .then(({ data }) => {
      dispatch({
        type: "GET_ALL_CRED_DESTINATARIOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllCredDestinatarios;
